import { render, staticRenderFns } from "./freeEvaluation.vue?vue&type=template&id=6d4bfd25&scoped=true"
import script from "./freeEvaluation.vue?vue&type=script&lang=js"
export * from "./freeEvaluation.vue?vue&type=script&lang=js"
import style0 from "./freeEvaluation.vue?vue&type=style&index=0&id=6d4bfd25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4bfd25",
  null
  
)

export default component.exports